/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import 'vue';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';

var classPrefixMixins = getClassPrefixMixins("fake-arrow");
var FakeArrow = mixins(classPrefixMixins).extend({
  name: "TFakeArrow",
  props: {
    isActive: {
      type: Boolean
    },
    overlayClassName: {
      type: [String, Object, Array]
    },
    overlayStyle: {
      type: Object
    }
  },
  computed: {
    classes: function classes() {
      return [this.componentName, _defineProperty({}, "".concat(this.componentName, "--active"), this.isActive), this.overlayClassName];
    }
  },
  render: function render() {
    var h = arguments[0];
    return h("svg", {
      "class": this.classes,
      "attrs": {
        "width": "16",
        "height": "16",
        "viewBox": "0 0 16 16",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      },
      "style": this.overlayStyle
    }, [h("path", {
      "attrs": {
        "d": "M3.75 5.7998L7.99274 10.0425L12.2361 5.79921",
        "stroke": "black",
        "stroke-opacity": "0.9",
        "stroke-width": "1.3"
      }
    })]);
  }
});

export { FakeArrow as default };
//# sourceMappingURL=fake-arrow.js.map
